import { gql } from "@apollo/client";

export const GET_TEMPLATE = gql`
	query GetTemplateData($params: TemplateQueryParam) {
		template(params: $params) {
			getTemplateData {
				body
				react
				subject
				templateId
			}
		}
	}
`;

export interface TemplateQueryInput {
	triggerHooks?: string;
	type?: string;
}
export type CommissionType = "a" | "p" | "e";
interface Commission {
	type: CommissionType;
	value: number;
	min?: number;
	includesGst: boolean;
}
interface BodyParam {
	customer: string;
	commission: Commission;
	examplePrice: string;
}

export interface TemplateParamsInput {
	body?: BodyParam;
	subject?: Record<string, any>;
	tempParams?: Record<string, any>;
	buttonDisabledMsg?: string;
}

export interface GetTemplateData {
	react?: boolean;
	body?: string;
	subject?: string;
	templateId?: string;
}

export interface GetTemplateResponse {
	template: {
		getTemplateData: GetTemplateData;
	};
}
